import URL from "../assets/conf/setting.json";
import SETTURL from "../assets/conf/setting.json";
import { resetURL } from "../../stempcore/src/sbase";
const apiUrl = URL.template.api.gateway.general;
const sbaseUrl = URL.sbaseUrl;
window.$sk.setApiUrl(apiUrl);
window.$sk.setUploadUrl(sbaseUrl);
resetURL(SETTURL);
export default {
  //获取模板配置
  getTemplateConfig: (params) => {
    return window.$sk.$skxhr("template/platform/instance/getConfig", params);
  },
  //获取服务器时间
  getServerTime: (params) => {
    return window.$sk.$skxhr("webinar/open/getServerTime", params);
  },
  //获取问卷信息
  getQuestionnaire: (params) => {
    return window.$sk.$skxhr("api/questionnaire/get", params);
  },
  //获取问卷规则
  getQuestionnaireRules: (params) => {
    return window.$sk.$skxhr("api/questionnaire/getrulelist", params);
  },
  //提交问卷信息
  questionaryAction: (params) => {
    return window.$sk.$skxhr("questionary/action", params);
  },
  //获取是否参与问卷
  getHasJoin: (params) => {
    return window.$sk.$skxhr("questionary/view", params);
  },
  //获取抽奖信息
  getLuckyDraw: (params) => {
    return window.$sk.$skxhr("luckyDraw/get", params);
  },
  //获取抽奖信息
  sendCheckCode: (params) => {
    return window.$sk.$skxhr("questionary/sendCheckCode", params);
  },
  //回填用户信息
  memberLookUp: (params) => {
    return window.$sk.$skxhr("member/LookUp", params);
  },
  //记录浏览行为
  browse: (params) => {
    return window.$sk.$skxhr("api/questionnaire/browse", params);
  },
  //获取随机试题
  getGenerateExam: (params) => {
    return window.$sk.$skxhr("questionary/exam/user/GenerateExam", params);
  },
  //提交随机问卷信息
  actionGenerateExam: (params) => {
    return window.$sk.$skxhr("questionary/exam/action", params);
  },
  //获取随机问卷答题记录
  getGenerateExamResult: (params) => {
    return window.$sk.$skxhr("questionary/exam/user/getSingleResult", params);
  },
  //用户开始答题
  questionnaireTimeStart: (params) => {
    return window.$sk.$skxhr("api/questionnaire/user/time/start", params);
  },
  //查询用户开始问卷多长时间接口
  questionnaireTimeGet: (params) => {
    return window.$sk.$skxhr("api/questionnaire/user/time/get", params);
  },
};
